import React from 'react'
import ReactDOM from 'react-dom'

import App from 'components/App'

import './styles/app.scss'

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js